import { z } from 'zod';
import { isValid } from 'date-fns';

/**
 * 문자열로 된 날짜가 유효한지 검증
 */
export const ValidDateStrSchema = z
  .string()
  .refine(
    (dateStr) => {
      if (!dateStr) return false; // 빈 문자열 방지

      try {
        return isValid(new Date(dateStr));
      } catch (e) {
        return false;
      }
    },
    {
      message: 'Must be a valid date string.',
    },
  )
  .transform((dateStr) => new Date(dateStr));

/**
 * Date 객체가 유효한 날짜가 맞는지 검증
 */
export const ValidDateSchema = z.date().refine((date) => isValid(date), {
  message: 'Must be a valid Date object.',
});

export const ValidDateRangeSchema = z
  .object({
    start: z.union([ValidDateStrSchema, ValidDateSchema]).optional(),
    end: z.union([ValidDateStrSchema, ValidDateSchema]).optional(),
  })
  .refine(
    (data) => {
      if (!data.start || !data.end) {
        return true;
      }
      return data.start < data.end;
    },
    {
      message: 'End date cannot be earlier than the start date.',
      path: ['end'],
    },
  );
